import {
  AnimationStyle,
  CameraMovement,
  type AnimationStyle as AnimationStyleType,
  type CameraMovement as CameraMovementType,
} from "../animated-image.ts";
import { styleConfigs } from "../animated-image-prompt-to-source-image-prompt.ts";

export type ParsedPromptType = {
  style?: AnimationStyleType;
  cameraMovement?: CameraMovementType;
};

const DELIMITER = ".";

export function parseAnimatedImagePromptType(raw: string): ParsedPromptType {
  const parts = raw.split(DELIMITER);

  if (parts.length === 1) {
    const part = parts[0]!;
    const cameraMovement = CameraMovement.safeParse(part);
    if (cameraMovement.success) {
      return { cameraMovement: cameraMovement.data };
    }
    return { style: AnimationStyle.parse(part) };
  }

  return {
    style: AnimationStyle.parse(parts[0]),
    cameraMovement: CameraMovement.parse(parts[1]),
  };
}

export function doesAnimatedImagePromptTypeReplaceStartImage(
  promptType: string | null,
): boolean {
  if (!promptType || promptType === "CUSTOM") return false;
  const parsed = parseAnimatedImagePromptType(promptType);
  if (!parsed.style) return false;
  return Boolean(styleConfigs[parsed.style]?.startImagePromptType);
}

export function buildPromptType(
  style: AnimationStyleType | null,
  cameraMovement: CameraMovementType | null,
): string {
  const prompt = [style, cameraMovement].filter(Boolean).join(DELIMITER);

  if (prompt.length === 0) {
    throw new Error("At least one of style or cameraMovement must be provided");
  }

  return prompt;
}
